export interface ReferralMoney {
  amount: number;
  currency: string;
}

export interface ReferralConfig {
  country: string;
  friendDiscount: ReferralMoney;
  referrerReward: ReferralMoney;
  policyVersion: string;
  thingsToKnow?: string[];
}

export interface ReferralMember {
  status: 'ready';
  code: string;
  shareUrl: string;
  country: string;
  friendDiscount: ReferralMoney;
  referrerReward: ReferralMoney;
}

export type ReferralMemberState =
  | { status: 'unissued'; code: null; shareUrl: null }
  | { status: 'provisioning'; code: string; shareUrl: null; country: string | null }
  | ReferralMember;

export interface ReferralStats {
  linksOpened: number;
  codesUsed: number;
  /** Mutually exclusive canonical actors; repeat orders never add boxes. */
  actors: { total: number; received: number; pending: number; noEligibleOrder: number };
  orders: { paid: number; shipped: number; cancelled: number };
  /** Received is awards less actual clawbacks, never less spending. */
  credit: { received: ReferralMoney; pending: ReferralMoney };
  asOf: string;
}
